/**
 * Preferred callback time slots — shared by the customer Create & Edit forms.
 * The selected option is stored verbatim as its readable string,
 * e.g. "8:00 AM - 10:00 AM".
 */
export const preferredCallTimes = [
  "8:00 AM - 10:00 AM",
  "10:00 AM - 12:00 PM",
  "12:00 PM - 2:00 PM",
  "2:00 PM - 4:00 PM",
  "4:00 PM - 6:00 PM",
];
